<template>
  <div>
    <base-header class="pb-6" />
    <b-container fluid class="mt--6 max-width">
      <b-card no-body>
        <card-header title="Sites">
          <base-button size="sm" @click="onNewSite">Add Site</base-button>
        </card-header>

        <el-table header-row-class-name="thead-light" :data="sites">
          <template #empty
            ><span v-if="loading"
              >Loading Sites <i class="fas fa-sync-alt fa-spin mr-1"></i></span
            ><span v-else>No Sites Found</span></template
          >

          <el-table-column
            class-name="font-weight-bold"
            label="Name"
            sortable
            prop="name"
          />

          <el-table-column label="Street"><div slot-scope="{row}">
              {{ row?.address?.street }} {{ row?.address?.number }}
          </div></el-table-column>

          <el-table-column
            label="Postal Code"
            sortable
            prop="address.postalcode"
          />

          <el-table-column label="Description" sortable prop="description" />

          <el-table-column min-width="50px" align="right">
            <div slot-scope="{ row }" class="table-actions">
              <base-button
                @click.native="onEdit(row)"
                class="remove btn-link"
                type=""
                size="sm"
                icon
              >
                <i class="text-dark fas fa-edit"></i>
              </base-button>

              <base-button
                @click.native="onDelete(row)"
                class="remove btn-link"
                type="danger"
                size="sm"
                icon
              >
                <i class="text-white fas fa-trash"></i>
              </base-button>
            </div>
          </el-table-column>
        </el-table>
      </b-card>
    </b-container>
  </div>
</template>

<!-- ###################################################################### -->

<script>
import CardHeader from "@/views/components/CardHeader";
import { Routes } from "@/router";
import { Action } from "@/store/actions";
import { mapState } from "vuex";
import { Table, TableColumn, Tooltip } from "element-ui";
import { confirmDelete } from "@/helper";

export default {
  name: "SiteList",
  components: {
    CardHeader,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    loadSites() {
      this.loading = true;
      this.$store
        .dispatch(Action.site.load)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.error("Failed to load devices:", error);
          this.loading = false;
        });
    },
    onNewSite() {
      this.$router.push({ name: Routes.siteNew });
    },
    onEdit(row) {
      this.$router.push({ name: Routes.siteEdit, params: { name: row.name } });
    },
    onDelete(row) {
      confirmDelete().then((result) => {
        if (result.value) {
          this.$store.dispatch(Action.site.delete, row);
        }
      });
    },
  },
  computed: {
    ...mapState({
      sites: (state) => state.site.sites,
    }),
  },
  mounted() {
    this.loadSites();
  },
};
</script>
